module.exports = __webpack_public_path__ + "static/media/load.677a27b0.svg";